"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCustomAuthStorage = exports.initialState = exports.default = exports.createFetchUserDataPromise = exports.createAmplifyUserResource = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _Resource = require("@jobmatchme/suspendable-resource/es/Resource");

var _hooks = require("@jobmatchme/suspendable-resource/es/hooks");

var _core = require("@aws-amplify/core");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var initialState = {
  isLoading: true,
  isError: false,
  user: null,
  isAuthenticated: false,
  isInternal: false,
  error: undefined
};
exports.initialState = initialState;

var authState = function authState(user) {
  return {
    isLoading: false,
    isError: false,
    user: user,
    isAuthenticated: true,
    isInternal: (user.signInUserSession.accessToken.payload['cognito:groups'] || []).includes('internal'),
    error: undefined
  };
};

var errorState = function errorState(error) {
  return {
    isLoading: false,
    isError: true,
    user: null,
    isAuthenticated: false,
    isInternal: false,
    error: error
  };
};

var createFetchUserDataPromise = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(loadAuth, adminOverride, bypassCache) {
    var AuthInstance, data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return loadAuth();

          case 3:
            AuthInstance = _context.sent;
            _context.next = 6;
            return AuthInstance.currentAuthenticatedUser(bypassCache ? {
              bypassCache: bypassCache
            } : undefined);

          case 6:
            data = _context.sent;
            return _context.abrupt("return", authState(adminOverride ? (0, _extends2.default)({}, data, {
              attributes: adminOverride(data.attributes)
            }) : data));

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", errorState(_context.t0));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function createFetchUserDataPromise(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Create an Amplify user resource.
 * This creates a resource based on the given promise, that suspences if the data has not finished loading
 *
 * The react suspense API might change in the future.
 * Refer to https://reactjs.org/docs/concurrent-mode-suspense.html from API changes
 *
 * @param {Promise<AuthClass>}  loadAuth       The lazyloaded amplify auth class used for this configuration
 * @param {(i: any) => any}     adminOverride  Optional override for state attibutes
 * @param {boolean}             bypassCache    Should the cache be explicitly bypassed (Forces a newtwork request)
 * @returns {AmplifyResourceType} suspending resource
 */


exports.createFetchUserDataPromise = createFetchUserDataPromise;

var createAmplifyUserResource = function createAmplifyUserResource(loadAuth, adminOverride, bypassCache) {
  return new _Resource.Resource(function () {
    return createFetchUserDataPromise(loadAuth, adminOverride, bypassCache);
  });
};
/**
 * Reads a custom state from session storage if set
 *
 * @returns {string | undefined} the custom oAuthState, if set
 */


exports.createAmplifyUserResource = createAmplifyUserResource;

var readCustomAuthStorage = function readCustomAuthStorage(identifier) {
  var storage = undefined;

  if (typeof window !== 'undefined') {
    try {
      var loaded = sessionStorage.getItem('oauth-custom-state:' + identifier);

      if (loaded) {
        storage = loaded; // If the storage has been read once, remove it

        sessionStorage.removeItem('oauth-custom-state');
      }
    } catch (error) {
      console.error('customOAuthStateError', {
        error: error
      });
    }
  }

  return storage;
};

var setCustomAuthStorage = function setCustomAuthStorage(identifier, value) {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem('oauth-custom-state:' + identifier, value);
  }
};
/**
 * Experimental Apmlify Provider with suspence support.
 * Improves Performance of UI by suspending components if amplify has not loaded the user yet.
 * Avoid rendering components multiple times when amplify state updates.
 *
 */


exports.setCustomAuthStorage = setCustomAuthStorage;

var AmplifyProvider = function AmplifyProvider(_ref2) {
  var loadAuth = _ref2.loadAuth,
      options = _ref2.options,
      children = _ref2.children,
      Context = _ref2.Context,
      UserResource = _ref2.UserResource,
      identifier = _ref2.identifier;

  var _bypassCache$adminOve = (0, _extends2.default)({
    bypassCache: false,
    adminOverride: undefined,
    signoutHook: false
  }, options),
      bypassCache = _bypassCache$adminOve.bypassCache,
      adminOverride = _bypassCache$adminOve.adminOverride,
      signoutHook = _bypassCache$adminOve.signoutHook;

  var _useResource = (0, _hooks.useResource)(UserResource),
      _useResource2 = (0, _slicedToArray2.default)(_useResource, 3),
      state = _useResource2[0],
      setState = _useResource2[2];

  var custom = (0, _react.useRef)(UserResource.read().isAuthenticated ? readCustomAuthStorage(identifier) : undefined);
  var fetchUserData = (0, _react.useCallback)(function (_bypassCache) {
    return createFetchUserDataPromise(loadAuth, adminOverride, _bypassCache || bypassCache).then(setState);
  }, [bypassCache, adminOverride, loadAuth]);
  (0, _react.useEffect)(function () {
    var onAuthEvent = function onAuthEvent(_ref3) {
      var payload = _ref3.payload;

      switch (payload.event) {
        case 'signIn':
        case 'signOut':
          fetchUserData();
          return;

        default:
          return;
      }
    };

    var unsubscribe = _core.Hub.listen('auth', onAuthEvent);

    return unsubscribe;
  }, [fetchUserData]);
  var handleSignout = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var AuthInstance;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return loadAuth();

          case 3:
            AuthInstance = _context2.sent;
            _context2.next = 6;
            return AuthInstance.signOut();

          case 6:
            if (signoutHook) {
              signoutHook();
            }

            window && localStorage.clear();
            window && sessionStorage.removeItem('jmmSession');
            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](0);
            console.error('handleSignoutError', {
              error: _context2.t0
            });

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 11]]);
  })), [signoutHook]);
  var value = (0, _react.useMemo)(function () {
    return (0, _extends2.default)({}, state, {
      custom: custom.current,
      handleSignout: handleSignout,
      loadAuth: loadAuth,
      fetchUserData: fetchUserData
    });
  }, [state, custom.current, handleSignout, loadAuth, fetchUserData]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Context.Provider, {
    value: value,
    children: children
  });
};

var _default = /*#__PURE__*/_react.default.memo(AmplifyProvider);

exports.default = _default;